import { useEffect, useState } from "react";
import { getNotificationsSubscription } from "src/requests/notifications/requests";
import { OptionsById, SubscriptionIds } from "../types";
import { getSubscriptionOptionsById, getSubscriptionsIds } from "../utils";

export const useSubscribedNotificationTemplates = () => {
  const [subscriptions, setSubscriptions] = useState<SubscriptionIds>();
  const [optionsById, setOptionsById] = useState<OptionsById>({});
  const [isFetching, setIsFetching] = useState(false);

  useEffect(() => {
    const fetchSubscriptions = async () => {
      setIsFetching(true);

      try {
        const { data } = await getNotificationsSubscription();
        setOptionsById(getSubscriptionOptionsById(data));
        setSubscriptions(getSubscriptionsIds(data));
      } catch (e) {
        console.error("Error during notification subscription fetch");
      } finally {
        setIsFetching(false);
      }
    };

    fetchSubscriptions();
  }, []);

  return {
    optionsById,
    subscribed: subscriptions?.subscribed ?? [],
    unsubscribed: subscriptions?.unsusbscribed ?? [],
    isFetching,
  };
};
